<template>
  <div class="w-editor-wrap">
    <div :id="editorId"></div>
  </div>
</template>

<script>
import E from 'wangeditor'
// 原生随机ID
function generateEditorId() {
  return 'editor_' + Date.now() + '_' + Math.floor(Math.random() * 100000);
}

export default {
  name: "WangEditor",
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      editor: null,
      editorId: generateEditorId()
    }
  },
  mounted() {
    this.initEditor()
  },
  watch: {
    value: {
      handler(val) {
        if(this.editor && val !== this.editor.txt.html()){
          this.editor.txt.html(val || '')
        }
      },
      immediate: true
    }
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy()
      this.editor = null
    }
  },
  methods: {
    initEditor() {
      const _this = this
      const editor = new E(`#${this.editorId}`)
      editor.config.placeholder = '请输入内容，可上传图片'

      // ==========修复：带上Authorization token============
      editor.config.customUploadImg = function (files, insert) {
        const form = new FormData()
        form.append('file', files[0])
        // 获取登录token
        const token = sessionStorage.getItem("token")
        _this.$http.post('File/UploadingFormFile', form, {
          headers: {
            Authorization: "Bearer " + token
          }
        }).then(res => {
          if(res.data.result){
            // 读取全局图片地址
            const url = _this.$root.imgserver + res.data.result
            insert(url)
          }
        }).catch(err=>{
          console.error("富文本图片上传失败：", err)
          _this.$message.error("图片上传失败！")
        })
      }

      editor.config.onchange = function (html) {
        _this.$emit('input', html)
      }
      editor.create()
      this.editor = editor
    },
    setContent(htmlStr) {
        if(this.editor){
            this.editor.txt.html(htmlStr || '')
        }
    }
  }
}
</script>

<style scoped>
.w-editor-wrap {
  border: 1px solid #dcdfe6;
}
::v-deep .w-e-text-container {
  min-height: 300px;
}
</style>